import { RenderMediaContent } from "src/components/RenderMediaContent"
import create_proxy_button from '../../assets/setup/proxy_buttons.m4v';
import proxy_buttons from '../../assets/setup/proxy_buttons.png';
// import disabled_proxy_button from '../../assets/setup/disabled_proxy_button.png';


// component props interface 
interface Props {
    isMobileView: boolean;
}

export const ProxyButtons: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center gap-y-1">
            <p>Create SAMMI button shortcuts and use them in other decks. They inherit the appearance and triggers of the original button.</p>

            <RenderMediaContent src={proxy_buttons} width={"800px"}/>

            <div className="mt-5">
                <ol className="flex flex-col gap-y-2 list-decimal list-inside">
                    <li>Once you create a link, the proxy button will automatically take on the appearance and triggers of the original button.  </li>
                    <li>You can make as many proxy buttons as you like and place them anywhere in SAMMI. </li>
                    <li>This way, you can create a deck of your favorite buttons without needing to move them. </li>
                    <li>Proxy buttons pointing to a buttons in disabled decks are not clickable and have a distinct sepia overlay.</li>
                </ol>
            </div>
            <div className="mt-4">
                <p>Please download and install <b><a href="https://christinak.itch.io/deck-hopper-advanced">Deck Hopper Advanced</a></b> extension, and run 'Create Proxy Button' button inside its premade deck.</p>
            </div>
           <RenderMediaContent src={create_proxy_button} />
        </div>
    )
}